import React from "react";

import cx from "classnames";

interface ApplyPageHeaderProps {
  button?: React.ReactNode;
  title?: string;
  description?: string;
  // NOTE(steven): "blue" variant is default; shows a blue header with overlapping content.
  // "bare" removes that for custom styling.
  variant?: "blue" | "bare";
}

export const ApplyPageHeader: React.FC<React.PropsWithChildren<Readonly<ApplyPageHeaderProps>>> = ({
  children,
  button,
  title,
  description,
  variant = "blue",
}) => (
  <div className={cx("w-full pt-8 md:pt-[80px] md:pb-[80px] pb-24", variant === "blue" ? "bg-od-blue" : "")}>
    <div className="max-w-6xl px-4 mx-auto text-center text-white">
      {button}
      <div className="pr-4 space-y-6 pb-[300px] md:pb-0">
        <h1 className="text-5xl font-light font-heading">{title}</h1>
        <p className="font-light text-md">{description}</p>
      </div>
      {children}
    </div>
  </div>
);
